// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__26us9","label":"LabeledBox_label__2l9UI"};